exports = module.exports = require("../../../../shared/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".client-spire-ca-element\r\n{\r\n/* \tdisplay: block; */\r\n/* \tposition: relative; */\r\n}\r\n\r\n.client-spire-ca-teacher-content\r\n{\r\n\tfont-size: 18pt;\r\n}\r\n\r\n.client-spire-teacher-passed-notification\r\n{\r\n\tclear: both;\r\n\tmargin-bottom: 0;\r\n}\r\n", ""]);

